<template>
  <footer v-reveal class="gx-footer">
    <div class="gx-footer__divider"></div>
    <div class="gx-footer__body">
      <div class="gx-footer__brand-col">
        <div class="gx-footer__brand">
          <img class="gx-footer__logo" src="https://xinghaohuo.oss-cn-beijing.aliyuncs.com/logo.png" alt="观星树 Logo">
          <span class="gx-footer__brand-text">
            <span class="gx-footer__name">观星树</span>
            <span class="gx-footer__sub">STAR · TREE</span>
          </span>
        </div>
        <p class="gx-footer__slogan">AI智能店铺运营，致力店铺无人化<br />从一粒种子，长成参天大树</p>
        <div class="gx-footer__socials">
          <span
            v-for="(s, i) in socials"
            :key="s.label"
            :title="s.label"
            class="gx-footer__social"
            :class="{ 'gx-footer__social--hov': hovSocial === i }"
            @mouseenter="hovSocial = i"
            @mouseleave="hovSocial = -1"
            @click="onSocial(s)"
          >{{ s.e }}</span>
        </div>
      </div>

      <div
        v-for="(col, ci) in cols"
        :key="col.title"
        class="gx-footer__col"
        :style="{ transitionDelay: `${(ci + 1) * 0.12}s` }"
      >
        <div class="gx-footer__col-title">{{ col.title }}</div>
        <div
          v-for="l in col.links"
          :key="l"
          class="gx-footer__link"
          :class="{ 'gx-footer__link--hov': hovLink === l }"
          @click="onLink(l)"
          @mouseenter="hovLink = l"
          @mouseleave="hovLink = ''"
        >
          <span v-if="isRouteLink(l)" class="gx-footer__link-arrow">›</span>{{ l }}
        </div>
      </div>
    </div>

    <div class="gx-footer__bar">
      <p class="gx-footer__copy">© 2026 观星树 Star Tree &nbsp;·&nbsp; 浙ICP备2021028918号</p>
      <div class="gx-footer__legal">
        <span
          v-for="l in ['隐私政策', '服务条款']"
          :key="l"
          class="gx-footer__legal-item"
          @mouseenter="$event.currentTarget.style.color = '#D4A946'"
          @mouseleave="$event.currentTarget.style.color = 'rgba(200,192,224,.3)'"
        >{{ l }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'NewUiFooter',
  data() {
    return {
      hovSocial: -1,
      hovLink: '',
      socials: [
        { e: '💬', label: '客服' },
        { e: '🎵', label: '抖音' },
        { e: '🌍', label: '官网' }
      ],
      cols: [
        { title: '产品', links: ['观星树', '星好货', '星检测', '星群控', '更多产品'] },
        { title: '资源', links: ['使用文档', '帮助中心', 'API文档', '更新日志'] },
        { title: '联系我们', links: ['客服微信', 'support@startree.ai', '企业合作'] }
      ]
    }
  },
  methods: {
    isRouteLink(l) {
      return l === '会员权益' || l === '关于我们'
    },
    onLink(l) {
      if (l === '会员权益') this.$emit('member')
      else if (l === '关于我们') this.$emit('about')
    },
    onSocial() {
      this.$emit('service')
    }
  }
}
</script>

<style scoped>
.gx-footer {
  background: linear-gradient(180deg, #0D1630 0%, #070E22 100%);
  border-top: 1px solid rgba(212, 169, 70, .14);
}
.gx-footer__divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(212, 169, 70, .4), transparent);
}
.gx-footer__body {
  max-width: 1160px;
  margin: 0 auto;
  padding: 72px 52px 0;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.2fr;
  gap: 56px;
  margin-bottom: 60px;
}
.gx-footer__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.gx-footer__logo {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: block;
  object-fit: contain;
  box-shadow: 0 0 22px rgba(212, 169, 70, .5);
  flex-shrink: 0;
}
.gx-footer__name {
  font-family: 'Noto Serif SC', serif;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: .04em;
  background: linear-gradient(135deg, #F0EBE0, #D4A946);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.gx-footer__sub {
  font-family: Inter, monospace;
  font-size: 9px;
  color: rgba(212, 169, 70, .55);
  letter-spacing: 3px;
}
.gx-footer__slogan {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(200, 192, 224, .55);
  line-height: 2;
  margin-bottom: 28px;
}
.gx-footer__socials {
  display: flex;
  gap: 10px;
}
.gx-footer__social {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .05);
  border: 1px solid rgba(255, 255, 255, .1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  cursor: pointer;
  transition: all 0.5s cubic-bezier(.22, 1, .36, 1);
}
.gx-footer__social--hov {
  background: rgba(212, 169, 70, .18);
  border-color: rgba(212, 169, 70, .6);
  transform: rotate(14deg) scale(1.2);
  filter: drop-shadow(0 0 8px rgba(212, 169, 70, .7));
}
.gx-footer__col-title {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #F0EBE0;
  margin-bottom: 22px;
  letter-spacing: .04em;
  opacity: .9;
  text-transform: uppercase;
}
.gx-footer__link {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(200, 192, 224, .5);
  margin-bottom: 14px;
  transition: color 0.5s cubic-bezier(.22, 1, .36, 1), transform 0.5s cubic-bezier(.22, 1, .36, 1);
}
.gx-footer__link--hov {
  color: #D4A946;
  transform: translateX(5px);
  cursor: pointer;
}
.gx-footer__link-arrow {
  font-size: 9px;
  color: rgba(212, 169, 70, .35);
}
.gx-footer__bar {
  border-top: 1px solid rgba(212, 169, 70, .1);
  padding: 20px 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gx-footer__copy {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(200, 192, 224, .32);
  margin: 0;
}
.gx-footer__legal {
  display: flex;
  gap: 20px;
}
.gx-footer__legal-item {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(200, 192, 224, .3);
  cursor: pointer;
  transition: color 0.5s cubic-bezier(.22, 1, .36, 1);
}
@media (max-width: 900px) {
  .gx-footer__body {
    grid-template-columns: 1fr 1fr;
    padding: 48px 24px 0;
    gap: 32px;
  }
  .gx-footer__bar {
    flex-direction: column;
    gap: 10px;
    padding: 20px 24px;
  }
}
</style>
